import { I18nt } from 'utils';
import { FormFieldValidationRules } from 'utils/interfaces';
import 'config/languages';

export default {
	nombre: [
		{ max: 100, message: I18nt('maximo', { max: 100 }) },
		{ required: true, message: I18nt('campo_requerido') },
	],
	apellido: [
		{ max: 100, message: I18nt('maximo', { max: 100 }) },
		{ required: true, message: I18nt('campo_requerido') },
	],
	correo: [
		{ required: true, message: I18nt('campo_requerido') },
		{ max: 100, message: I18nt('maximo', { max: 100 }) },
		{ type: 'email', message: I18nt('formato_invalido_vuelve') },
	],
	tipo: [{ required: true, message: I18nt('campo_requerido') }],
	mensaje: [
		{ max: 2000, message: I18nt('maximo', { max: 2000 }) },
		{ required: true, message: I18nt('campo_requerido') },
	],
} as FormFieldValidationRules;
